<template>
  <div class="wrapper">
    <div class="main visual-2 /enter-phone visual-6">
      <Header backRoute="/chose-option" />
      <div class="vis4-inr1">
        <h1>Enter Your Full Name</h1>
        <form
          class="namesearch nameform"
          id="nameform"
          @submit.prevent="handleSubmit"
        >
          <div class="fieldgroup">
            <label for="firstname">First Name</label>
            <input
              type="text"
              id="firstname"
              v-model="firstName"
              placeholder="John"
              required
              maxlength="15"
            />
          </div>

          <div class="fieldgroup">
            <label for="lastname">Last Name</label>
            <input
              type="text"
              id="lastname"
              v-model="lastName"
              placeholder="Doe"
              required
              maxlength="15"
            />
          </div>

          <div class="sbmt">
            <button type="submit">Next</button>
          </div>
        </form>
      </div>
      <FooterView />
    </div>
  </div>
</template>

<script>
import FooterView from "@/layout/Footer.vue";
import Header from "@/layout/Header.vue";

export default {
  components: {
    FooterView,
    Header,
  },
  name: "EnterName",
  data() {
    return {
      firstName: "",
      lastName: "",
    };
  },
  mounted() {
    // ✅ Restore saved data if available
    const savedPatient = JSON.parse(localStorage.getItem("patient"));
    if (savedPatient) {
      this.firstName = savedPatient.firstname || "";
      this.lastName = savedPatient.lastname || "";
    }
  },
  methods: {
    handleSubmit() {
      const patient = {
        firstname: this.firstName,
        lastname: this.lastName,
      };

      localStorage.setItem("patient", JSON.stringify(patient));
      this.$router.push({
        path: "/enter-email",
        query: this.$route.query.code ? { code: this.$route.query.code } : {},
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    // ✅ If user navigates back to chose-option, clear localStorage
    if (to.path === "/chose-option") {
      localStorage.removeItem("patient");
    }
    next();
  },
};
</script>
